const VENDER_VIEW_PAGE_TYPE_BY_PAGE = {
  home: 'home',
  about: 'companyIntro',
  contact: 'contactInfo',
}

export const getVenderViewPageType = (pageType) =>
  VENDER_VIEW_PAGE_TYPE_BY_PAGE[pageType] || VENDER_VIEW_PAGE_TYPE_BY_PAGE.home

export const getVenderViewTrackingParams = (pageType) => ({
  isAddView: true,
  pageType: getVenderViewPageType(pageType),
})
